export default __webpack_public_path__ + "static/media/icon-bills.d12f1fe3.svg";